<template>
  <section class="foyer2d" ref="section" id="foyer2D">
    <Header id="foyer2DHeader" v-if="!hideHeader" />
    <!-- <div class="visited-experimental"></div> -->
    <!-- <img usemap="#standsImageMap" :class="{'isHideHeader':hideHeader}" class="stands-background-image" ref="imageBase" :src="stands.image" alt @load="onBaseImageLoaded"/> -->
    <map name="standsImageMap" ref="standsImageMap" class="area-and-overlay-items" v-dragscroll.pass="enableScroll">
      <img usemap="#standsImageMap" :class="{ isHideHeader: hideHeader }" class="stands-background-image" ref="imageBase" :src="stands.image" alt @load="onBaseImageLoaded" />
      <div v-for="area in stands.areas" :key="area.title">
        <!-- AREA -->
        <area href="#" :coords="area.coords" shape="rect" :title="area.title" @click.prevent="baseClicked" />

        <!-- OVERLAY -->
        <div
          :id="area.title"
          class="overlay-item"
          :class="{ isHideHeader: hideHeader }"
          :style="{ justifyContent: activityData.property.foyer2DInfospotAlign, alignItems: activityData.property.foyer2DInfospotJustify }"
          @click.prevent="overlayClicked(area)"
          v-if="activityData.property.foyer2DInfospot">
          <span class="overlay-item-wrapper" :style="{ justifyContent: activityData.property.foyer2DInfospotAlign, alignItems: activityData.property.foyer2DInfospotJustify }">
            <div class="overlay-item-bubble" :style="{ color: activityData.property.foyer2DHintTextColor, background: activityData.property.foyer2DHintBGColor, borderRadius: activityData.property.foyer2DHintBorderRadius }" v-if="area.hint">
              <span v-html="area.hint"></span>
            </div>
            <div class="overlay-infospot" v-if="baseImageLoaded">
              <i
                :class="`${activityData.property.foyer2DInfospotFAIconClass ? activityData.property.foyer2DInfospotFAIconClass : 'far fa-dot-circle'} infospot-fa`"
                :style="{ color: activityData.property.foyer2DInfospotColor, fontSize: activityData.property.foyer2DInfospotFAIconSize }"></i>
            </div>
          </span>
        </div>
      </div>
    </map>
    <!-- VISITED CHECKMARK -->
    <div class="visited" v-if="showCheckmarks">
      <div class="visited-checkmark" v-for="(checkmark, key) in visited" :key="key" ref="checkmarks" :id="'id' + key"></div>
    </div>
    <!-- STAND POPUP -->
    <div class="stand-popup-container" v-if="showPopup && hasPopUp">
      <transition appear name="fade">
        <!-- <img usemap="#standImageMap" class="stand-background-image" ref="standImage" :src="stand.image" alt @load="onSubImageLoaded" v-show="stand.image? !stand.image.endsWith('html'):false" /> -->
        <!-- WITH CARROUSSEL ANIMATION -->
        <img
          usemap="#standImageMap"
          class="stand-background-image"
          :class="{ animateNextStand: animateNextStand && useFoyer2DNavigationAnimation, animatePreviousStand: animatePreviousStand && useFoyer2DNavigationAnimation }"
          ref="standImage"
          :src="stand.image"
          alt
          @load="onSubImageLoaded"
          v-show="stand.image ? !stand.image.endsWith('html') : false" />
      </transition>
      <map name="standImageMap" ref="standImageMap">
        <area v-for="area in stand.areas" :key="area.title" href="#" :coords="area.coords" shape="rect" :title="area.title" @click.prevent="subClicked" />
      </map>
      <transition appear name="fade">
        <iframe style="width: 90vw; height: 80vh; z-index: 1" v-if="stand.image ? stand.image.endsWith('html') : false" :src="stand.image" frameborder="0"></iframe>
      </transition>

      <!-- CLOSE -->
      <div class="stand-close-btn" @click.prevent="showPopup = false">
        <ion-icon name="close-circle" :style="{ paddingRight: '4px', fontSize: '3rem', color: activityData.property.foyer2DNavigationColor ? activityData.property.foyer2DNavigationColor : '#ffffff80' }"></ion-icon>
      </div>

      <!-- PREVIOUS -->
      <div class="stands-previous-btn" @click.prevent="previousStand" v-if="activityData.property.foyer2DNavigation">
        <i class="fas fa-chevron-circle-left" :style="{ fontSize: '3rem', color: activityData.property.foyer2DNavigationColor ? activityData.property.foyer2DNavigationColor : '#ffffff80' }"></i>
      </div>
      <!-- NEXT -->
      <div class="stands-next-btn" @click.prevent="nextStand" v-if="activityData.property.foyer2DNavigation">
        <i class="fas fa-chevron-circle-right" :style="{ fontSize: '3rem', color: activityData.property.foyer2DNavigationColor ? activityData.property.foyer2DNavigationColor : '#ffffff80' }"></i>
      </div>
    </div>
    <!-- DETAILS POPUP -->
    <div class="stand-details-container" v-if="showDetails && hasPopUp">
      <iframe class="stand-details-video-iframe" v-if="details.video" :src="details.video" frameborder="0" allow="autoplay; encrypted-media;" allowfullscreen></iframe>
      <media-display class="stand-details-gallery" :autoPlay="false" :wheelControl="true" :mouseDrag="true" :trimWhiteSpace="true" v-if="details.images ? details.images.length : false">
        <media-slide v-for="(image, key) in details.images" :key="key">
          <img class="stand-gallery-image" :src="image.url" @click="imageDisplayHandler(details.images)" />
        </media-slide>
        <media-navigation slot="hooper-addons" v-if="details.images"></media-navigation>
        <media-pagination slot="hooper-addons" v-if="details.images"></media-pagination>
      </media-display>
      <!-- <v-gallery type="carousel" class="stand-details-gallery" :images="details.images" v-if="details.images"></v-gallery> -->
      <img class="stand-background-image" v-if="details.image" ref="standImage" :src="details.image" alt />
      <div class="checkmark-feedback" v-if="details.checkmark">
        <ion-icon name="checkmark-circle-outline" class="success"></ion-icon>
        <br />
      </div>
      <div class="stand-details-close-btn" @click.prevent="showDetails = false"><ion-icon name="close-circle"></ion-icon></div>
    </div>
    <div class="footer-wrapper">
      <img class="foyer2d-instructions" :src="imageHelp" v-if="imageHelp" alt />
      <Footer v-if="!externalStream" />
    </div>
  </section>
</template>
<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api.js';
import { dragscroll } from 'vue-dragscroll';
import { Hooper as MediaDisplay, Slide as MediaSlide, Navigation as MediaNavigation, Pagination as MediaPagination } from 'hooper';

export default {
  name: 'Foyer2D',
  components: {
    Header,
    Footer,
    MediaDisplay,
    MediaSlide,
    MediaNavigation,
    MediaPagination,
  },
  directives: {
    dragscroll,
  },
  props: ['externalStream', 'standFromLink'],
  data() {
    return {
      stands: [], //standsJSON
      stand: {},
      details: {},
      visited: [],
      visitedTemp: [],
      deltaXSum: 0,
      deltaYSum: 0,
      hasPopUp: false,
      showPopup: false,
      showDetails: false,
      enableScroll: false,
      standsNaturalImageMapCoords: [],
      standNaturalImageMapCoords: [],
      activityData: { images: {}, interactivities: [] },
      title: '',
      hideHeader: true,
      showCheckmarks: true,
      checkmarksCollection: [],
      uniqueCheckmarksCollection: [],
      activeStand: '',
      imageHelp: '',
      animateNextStand: false,
      animatePreviousStand: false,
      baseImageLoaded: false,
      subImageLoaded: false,
      nextClicked: false,
      previousClicked: false,
      useFoyer2DNavigationAnimation: false,
    };
  },
  watch: {
    $route() {
      this.loadActivity();
      this.showPopup = false;
      this.showDetails = false;
    },
  },
  methods: {
    loadActivity() {
      api
        .get(`activity/${this.externalStream ? this.externalStream : this.$route.params.stream}`)
        .then((response) => {
          //console.log(response);

          let tempImages = { ...this.activityData.images };
          this.activityData = { ...this.activityData, ...response.data };
          this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;

          let tempProperty = { ...this.activityData.property };
          this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;

          response.data.interactivity.forEach((item) => {
            this.activityData.interactivities[item.interactivity] = item.enable;
          });

          this.title = this.activityData.activity;
          this.imageHelp = this.activityData.property.imageHelp ? this.activityData.property.imageHelp : this.imageHelp;
          this.hideHeader = this.activityData.property.hideHeader ? true : false;
          if (this.externalStream) this.hideHeader = true;
          if (this.activityData.property.foyer2DNavigationAnimation) this.useFoyer2DNavigationAnimation = true;

          // console.log('activity: ', this.activityData);
        })
        .then(() => {
          this.stands = this.activityData.property;
          this.hasPopUp = this.activityData.property.hasPopUp;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onBaseImageLoaded() {
      // console.log('BASE IMAGE LOADED');
      this.initBaseImageMap('standsImageMap');
      this.resizeBaseImageMap();
      setTimeout(() => {
        this.baseImageLoaded = true;
        if (this.standFromLink) {
          this.baseClicked({ target: { title: this.standFromLink } });
        }
      }, 700);
    },
    onSubImageLoaded() {
      this.initSubImageMap('standImageMap');
      this.resizeSubImageMap();
      this.subImageLoaded = true;

      if (this.nextClicked) {
        this.nextClicked = false;
        this.animateNextStand = true;
        // console.log('SUB IMAGE LOADED:', this.subImageLoaded);
        setTimeout(() => {
          this.animateNextStand = false;
        }, 500);
      }
      if (this.previousClicked) {
        this.previousClicked = false;
        this.animatePreviousStand = true;
        // console.log('SUB IMAGE LOADED:', this.subImageLoaded);
        setTimeout(() => {
          this.animatePreviousStand = false;
        }, 500);
      }
    },
    baseClicked(e) {
      if (!this.hasPopUp) {
        this.details = this.stands[e.target.title];
        this.showDetails = true;
        this.$nextTick(() => {
          if (e.target.title == 'AJUDA') {
            // console.log('AJUDA!!!!: ' + JSON.stringify(e.target.title));
            alert(`Olá, para iniciar o evento e entrar em sua reunião, você deve clicar na unidade de negócios de sua franquia e escolher o horário e data pertinentes ao momento.
Caso precise de alguma informação ou ajuda, é só entrar em contato pelo email: suporte.ache@convencaoache2021.com.br ou pelo Whatsapp: +55 11 99498-9791`);
          } else if (e.target.title == 'ATIVIDADES LIVRES') {
            if (
              confirm(`Olá Geração Aché!
Nosso espaço de atividades livres foi criado pensando única e exclusivamente em seu entretenimento. Todos os conteúdos oferecidos aqui são de lazer e livre participação, sendo independentes dos conteúdos oficiais apresentados em agenda durante a Convenção de Vendas 2021 e não exigem a sua participação.
Se você concorda, clique em ok e divirta-se!`)
            ) {
              this.$router.push(this.details);
              // console.log('YES.');
            } else {
              // Do nothing!
              // console.log('NO.');
            }
          } else {
            if (this.details.name) {
              this.showDetails = false;
              this.$router.push(this.details);
            }
            if (this.details.url) {
              window.open(this.details.url);
              this.details.url = null;
              this.showDetails = false;
            }
          }
          api.post(`sessionAction/`, {
            action: 'Foyer2D Action - Base Simple',
            properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, stand: this.stands, action: this.details }),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
        });
      } else {
        this.currentStandTitle = e.target.title;
        this.stand = this.stands[e.target.title];
        this.details = this.stands[e.target.title];
        if (this.details.name) {
          this.showDetails = true;

          this.showDetails = false;
          this.$router.push(this.details);
        }
        if (this.details.url) {
          this.showDetails = true;

          window.open(this.details.url);
          this.details.url = null;
          this.showDetails = false;
        }
        this.showPopup = true;

        // PEGAMOS O NOME DO STAND PARA CAGUETAGEM
        this.activeStand = e.target.title;
        // console.log('activeStand: ' + this.activeStand);
      }
      this.$nextTick(() => {
        if (this.details.url) {
          window.open(this.details.url);
          this.details.url = null;
          this.showDetails = false;
        }
        api.post(`sessionAction/`, {
          action: 'Foyer2D Action - Base',
          properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, stand: this.activeStand, action: this.details }),
          userid: this.$store.state.user.id,
          sessionid: this.$store.state.user.token,
          event_id: this.$store.state.eventId,
        });
      });
    },
    subClicked(e) {
      this.details = this.stand[e.target.title];
      this.showDetails = true;
      this.$nextTick(() => {
        if (this.details.checkmark) {
          // console.log('CHECKMARK: ' + this.activeStand);
        }
        if (this.details.url) {
          // console.log('details: ', this.details);
          window.open(this.details.url);
          this.showDetails = false;
          // this.details.url = null;
        }
        if (this.details.name) {
          if (this.details.name != 'MENSAGEM') {
            this.showDetails = false;
            this.$router.push(this.details);
          } else {
            if (this.details.id != this.$store.state.user.id) {
              const cName = this.details.id > this.$store.state.user.id ? this.details.id + this.$store.state.user.id : this.$store.state.user.id + this.details.id;
              api
                .post(`event/${this.$store.state.eventId}/createTalkChannel`, { user_id: this.details.id, channelName: cName })
                .then((response) => {
                  //console.log(response);
                  if (response.data) {
                    this.$router
                      .push({
                        name: 'Messages',
                        params: {
                          channelId: response.data.talk_channel_id,
                        },
                      })
                      .catch((err) => {
                        console.log('navigation error', err);
                      });
                  }
                })
                .catch((err) => {
                  console.error(err);
                });
            }
            this.showDetails = false;
            this.$router.push(this.details);
          }
        }
        api.post(`sessionAction/`, {
          action: 'Foyer2D Action - Sub',
          properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, stand: this.activeStand, action: this.details }),
          userid: this.$store.state.user.id,
          sessionid: this.$store.state.user.token,
          event_id: this.$store.state.eventId,
        });
        // if (this.details.url) {
        //   this.details.url = null;
        // }
      });
    },
    overlayClicked(area) {
      this.baseClicked({ target: { title: area.title } });
    },
    initBaseImageMap(areasRef) {
      let areas = this.$refs[areasRef].getElementsByTagName('area');
      let coords = [];
      for (let n = 0; n < areas.length; n++) {
        coords[n] = areas[n].coords.split(',');
      }
      this.standsNaturalImageMapCoords = coords.slice();
    },
    resizeBaseImageMap() {
      let coords = JSON.parse(JSON.stringify(this.standsNaturalImageMapCoords));
      let areas = this.$refs.standsImageMap.getElementsByTagName('area');
      // console.log({ areas });

      let overlays = this.$refs.standsImageMap.getElementsByClassName('overlay-item');
      // console.log({ overlays });

      let ratio = this.$refs.imageBase.width / this.$refs.imageBase.naturalWidth;
      // console.log("imageBase width: ", this.$refs.imageBase.width )
      for (let n = 0; n < areas.length; n++) {
        let coordsLenght = coords[n].length;
        for (let m = 0; m < coordsLenght; m++) {
          coords[n][m] *= ratio;
        }
        areas[n].coords = coords[n].join(',');
        // console.log(areas[n].coords.split(','));

        if (this.activityData.property.foyer2DInfospot) {
          overlays[n].style.bottom = `${areas[n].coords.split(',')[3]}px`;
          overlays[n].style.top = `${areas[n].coords.split(',')[1]}px`;
          overlays[n].style.left = `${areas[n].coords.split(',')[0]}px`;
          // overlays[n].style.right = `${areas[n].coords.split(',')[2]}px`;
          overlays[n].style.width = `${areas[n].coords.split(',')[2] - areas[n].coords.split(',')[0]}px`;
          overlays[n].style.height = `${areas[n].coords.split(',')[3] - areas[n].coords.split(',')[1]}px`;
        }
      }
      // SCROLL TO MIDDLE
      this.$nextTick(() => {
        // console.log('this.$refs.section.scrollWidth: ' + this.$refs.section.scrollWidth);
        // console.log('document.body.clientWidth: ' + document.body.clientWidth);
        this.$refs.standsImageMap.scrollTop = this.$refs.section.scrollHeight / 2 - 100;
        this.$refs.standsImageMap.scrollLeft = (1920 - document.body.clientWidth) / 2;
        if (window.innerWidth > 706) {
          this.enableScroll = false;
        } else {
          // this.$$refs.section.style.
          this.enableScroll = true;
        }
      });
    },
    initSubImageMap(areasRef) {
      let areas = this.$refs[areasRef].getElementsByTagName('area');
      let coords = [];
      for (let n = 0; n < areas.length; n++) {
        coords[n] = areas[n].coords.split(',');
      }
      this.standNaturalImageMapCoords = coords.slice();
    },
    resizeSubImageMap() {
      let coords = JSON.parse(JSON.stringify(this.standNaturalImageMapCoords));
      let areas = this.$refs.standImageMap.getElementsByTagName('area');
      let ratio = this.$refs.standImage.width / this.$refs.standImage.naturalWidth;
      for (let n = 0; n < areas.length; n++) {
        let clen = coords[n].length;
        for (let m = 0; m < clen; m++) {
          coords[n][m] *= ratio;
        }
        areas[n].coords = coords[n].join(',');
      }
    },
    receiveMessage(incoming) {
      let msg = JSON.parse(incoming.data);

      if (msg.type == 'chat-message') {
        this.messages.push(msg);
        this.$nextTick(() => {
          this.$refs.chatBox.updatePosition();
        });
      } else if (msg.type == 'begin-quiz') {
        this.showQuiz = true;
        this.$nextTick(() => {
          this.$refs.quiz.beginQuiz(msg.quizQuestions);
        });
      } else if (msg.type == 'end-quiz') {
        this.$refs.quiz.endQuiz();
        this.showQuiz = false;
      } else if (msg.type == 'quiz-score') {
        this.$refs.quiz.setScore(msg.score);
      } else if (msg.type == 'begin-poll') {
        this.showPoll = true;
        this.$nextTick(() => {
          this.$refs.poll.beginPoll(msg.poll);
        });
      } else if (msg.type == 'end-poll') {
        this.$refs.poll.endPoll();
        this.showPoll = false;
      } else if (msg.type == 'update-interaction-poll') {
        this.$refs.poll.updatePoll(msg.answers, msg.totalVotes);
      } else if (msg.type == 'begin-notification') {
        this.notificationActive = true;
        //this.notification = msg.notification;
        //console.log('Begin Notification!', msg);
      } else if (msg.type == 'end-notification') {
        this.notificationActive = false;
      } else if (msg.type == 'qna-live') {
        this.showQA = msg.value;
      } else if (msg.type == 'link-live') {
        this.showMeetLink = msg.value;
      } else if (msg.type == 'header-show') {
        this.hideHeader = msg.value;
      } else if (msg.type == 'stream-live') {
        this.streamActive = msg.value;
        this.$gtag.event('stream', {
          event_category: 'stream_status',
          value: msg.value ? 'started' : 'stopped',
        });
        if (!this.streamActive) {
          this.$nextTick(() => {
            // this.player = videojs(this.$refs.player);
            // this.player.play();
          });
        }
      }
    },
    nextStand() {
      this.subImageLoaded = false;
      this.nextClicked = true;

      let stands = JSON.parse(JSON.stringify(this.stands));
      let standsEntries = Object.entries(stands);
      stands = standsEntries.filter((item) => !item[1].name);
      stands = stands.map((item) => item[0]);

      let areas = JSON.parse(JSON.stringify(this.stands.areas));
      areas = areas.filter((area) => stands.includes(area.title));

      let entries = Object.entries(areas);
      let nextStand = '';
      let lastItem = entries.slice(-1)[0];
      let firstItem = entries.slice(0)[0];

      entries.map((area) => {
        if (this.activeStand == area[1].title) {
          if (parseInt(area[0]) == lastItem[0]) {
            nextStand = firstItem[1].title;
          } else nextStand = entries[parseInt(area[0]) + 1][1].title;
        }
      });
      this.activeStand = nextStand;
      this.stand = this.stands[nextStand];
      api.post(`sessionAction/`, {
        action: 'Foyer2D Action - NextStand',
        properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, stand: this.activeStand, action: this.details }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
    },
    previousStand() {
      this.subImageLoaded = false;
      this.previousClicked = true;

      let stands = JSON.parse(JSON.stringify(this.stands));
      let standsEntries = Object.entries(stands);
      stands = standsEntries.filter((item) => !item[1].name);
      stands = stands.map((item) => item[0]);

      let areas = JSON.parse(JSON.stringify(this.stands.areas));
      areas = areas.filter((area) => stands.includes(area.title));

      let entries = Object.entries(areas);
      let nextStand = '';
      let lastItem = entries.slice(-1)[0];
      let firstItem = entries.slice(0)[0];

      entries.map((area) => {
        if (this.activeStand == area[1].title) {
          if (parseInt(area[0]) == firstItem[0]) {
            nextStand = lastItem[1].title;
          } else nextStand = entries[parseInt(area[0]) - 1][1].title;
        }
      });
      this.activeStand = nextStand;
      this.stand = this.stands[nextStand];
      api.post(`sessionAction/`, {
        action: 'Foyer2D Action - PreviousStand',
        properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, stand: this.activeStand, action: this.details }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
    },
    scrollY() {
      // console.log(this.$refs.section.scrollTop);
      // console.log(this.$refs.section.scrollHeight / 2);
      let headerHeight = document.getElementById('foyer2DHeader').offsetHeight - (window.innerHeight <= 460 ? 10 : 0);
      this.stands.areas.map((area) => {
        document.getElementById(area.title).style.marginTop = `${-this.$refs.section.scrollTop + headerHeight}px`;
      });
    },
    handlePopupKeypress(e) {
      if (this.showPopup && !this.showDetails) {
        if (e.key == 'ArrowLeft') this.previousStand();
        if (e.key == 'ArrowRight') this.nextStand();
      }
    },
    imageDisplayHandler(images) {
      // console.log(images);
      this.showImageFull = !this.showImageFull;
      this.imageFull = images;
    },
  },
  beforeMount() {
    this.loadActivity();
  },
  mounted() {
    window.addEventListener('resize', this.resizeBaseImageMap);
    window.addEventListener('keydown', this.handlePopupKeypress);
    this.$refs.section.addEventListener('scroll', this.scrollY);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeBaseImageMap);
    window.removeEventListener('keydown', this.handlePopupKeypress);
    this.$refs.section.addEventListener('scroll', this.scrollY);
  },
};
</script>
<style lang="scss">
.foyer2d {
  min-height: 100dvh;
  // background-color: var(--main-color);
  overflow-x: auto;
  overflow-y: auto;
}
.stands-previous-btn {
  cursor: pointer;
  // pointer-events: none;
  position: absolute;
  left: 2%;
  top: 22%;
  width: 10%;
  height: 60%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 1000;
  // background: red;

  @include media('<=phone-plus') {
    position: absolute;
    left: 2%;
    top: 76%;
    width: 48%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: red;
  }
}
.stands-next-btn {
  cursor: pointer;
  // pointer-events: none;
  position: absolute;
  right: 2%;
  top: 22%;
  width: 10%;
  height: 60%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 1000;
  // background: red;

  @include media('<=phone-plus') {
    position: absolute;
    top: 76%;
    width: 48%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: red;
  }
}
.area-and-overlay-items {
  height: 100%;
  width: 100%;
  // position: absolute;
}
.overlay-item {
  // background-color: #40404040;
  cursor: pointer;
  position: absolute;
  margin-top: 99px;
  @include media('<=phone') {
    margin-top: 50px;
  }
  @media (max-height: 460px) {
    margin-top: 40px;
  }
  display: flex; //developing feature = flex
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  // pointer-events: none;
}
.overlay-item-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
}
.overlay-infospot {
  display: flex;
  justify-content: center;
  align-items: center;
  // background: red;
  width: auto;
  height: 20%;
  z-index: 0;
  animation: fade 5s infinite;
  -webkit-animation: fade 5s infinite;
  .infospot-fa {
    color: var(--main-color);
    font-size: 1.3rem;
  }
}
.overlay-item-bubble {
  position: relative;
  background: var(--main-color);
  padding: 10px 20px !important;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-color);
  text-align: center;
  opacity: 0; //opacity 0 fora anim
  transition: 0.3s;
  z-index: 1;
  &:hover {
    opacity: 1;
  }
}
.overlay-item:hover ~ .overlay-item-bubble {
  opacity: 1;
}
.overlay-item-wrapper:hover > .overlay-item-bubble {
  opacity: 1;
}
@keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
}

@-webkit-keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
}
.visited-checkmark {
  display: none;
  position: absolute;
  background-color: green;
  height: 30px;
  width: 30px;
  @include media('<=phone-plus') {
    // visibility: hidden;
    background-color: transparent;
  }
}
.visited-experimental {
  visibility: hidden;
  position: fixed;
  background-color: red;
  height: 300px;
  width: 300px;
}
.stands-background-image {
  margin-top: 99px;
  height: auto;
  width: 100vw;
  @include media('<=phone-plus') {
    // margin-top: 40px;
    width: 1920px;
  }
  @include media('<=phone') {
    margin-top: 40px;
  }
  @media (max-height: 460px) {
    margin-top: 40px;
  }
}
.isHideHeader {
  margin-top: 0px;
}
.success {
  color: green;
  font-size: 5rem;
}
area {
  outline: none;
}
.stand-popup-container {
  position: fixed;
  left: 0vw;
  right: 0vw;
  top: 99px;
  bottom: 32px;
  background-color: rgba($color: white, $alpha: 0);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  .stand-background-image {
    z-index: 1;
    // margin-top: 100px;
    max-height: 85vh;
    max-width: 90vw;

    // -webkit-transition-property: transform;
    // -webkit-transition-duration: 500ms;
    // transition-property: transform;
    // transition-duration: 500ms;
    @include media('<=phone-plus') {
      // width: 1920px;
    }
  }
}
.animatePreviousStand {
  animation: previousStand 0.5s;
}
@keyframes previousStand {
  0% {
    transform: translateX();
  }
  20% {
    transform: translateX(100vw);
  }
  21% {
    transform: translateX(-100vw);
  }
  100% {
    transform: translateX(0);
  }
}
.animateNextStand {
  animation: nextStand 0.5s;
}
@keyframes nextStand {
  0% {
    transform: translateX();
  }
  20% {
    transform: translateX(-100vw);
  }
  21% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(0);
  }
}
.stand-details-container {
  position: fixed;
  left: 0vw;
  right: 0vw;
  top: 99px;
  bottom: 32px;
  background-color: rgba($color: black, $alpha: 0.6);
  // color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  .checkmark-feedback {
    color: var(--text-color);
    background-color: rgba($color: black, $alpha: 0.6);
    border-radius: 10px;
    position: relative;
    z-index: 2;
    width: 30vw;
    height: 10vw;
    font-size: 2vw;
    text-align: center;
    padding-top: 1.1%;
    &::after {
      content: 'Obrigado pela visita!';
    }
  }
  .stand-background-image {
    z-index: 2;
    // margin-top: 100px;
    max-height: 90vh;
    max-width: 96vw;
    @include media('<=phone-plus') {
      // width: 1920px;
    }
  }
  .stand-details-video-iframe {
    position: relative;
    z-index: 2;
    width: 60.4vw;
    height: 34vw;
  }
  .stand-details-gallery {
    position: fixed;
    top: 100px;
    bottom: 0;
    z-index: 2;
    width: 100%;
    height: calc(90% - 100px);
    padding-top: 50px;
    // min-height: 100dvh;
    margin-bottom: 200px;
    background: #00000080;
  }
  //CUSTOM GALLERY
  .image-box {
    a {
      position: relative;
      z-index: 2;
      background-color: #232323;
      // clear: both;
      display: inline-block;
      margin: 0 10px 10px 0;
      text-align: center;
      .bgbox {
        background-color: #232323;
        // height: 150px;
        display: table-cell;
        vertical-align: middle;
        padding: 4px;
        border-radius: 4px;
        img {
          width: 30vw;
          display: block;
        }
      }
      .img-title {
        display: block;
        text-align: center;
        color: #999999;
        padding: 5px 0 10px 0;
      }
      &:hover {
        .img-title {
          color: white;
        }
      }
    }
  }
}
.v-gallery {
  position: relative;
}
.blueimp-gallery-display {
  background-color: #202020ee !important;
  max-width: unset !important;
  margin: 0 auto !important;
  height: 94vh !important;
  width: 100% !important;
}
// .slides {
//   // max-width: initial !important;
//   // margin: 0 auto !important;
//   // height: 94vh !important;
//   // width: 100% !important;
//   // background: red;
// }
.slide {
  margin-top: -60px;
  // min-width: 1200px !important;
  width: 100vw !important;
  img {
    object-fit: contain !important;
    height: 80% !important;
    width: 80% !important;
  }
}
.title {
  display: none !important;
}
.close {
  position: absolute !important;
  top: 88vh !important;
  bottom: 0px !important;
  background-color: black !important;
  width: 100vw !important;
  // transform: translateX(25px) !important;
}
// .stand-close-btn {
//   cursor: pointer;
//   position: absolute;
//   top: 0;
//   right: 0;
//   background-color: rgba($color: black, $alpha: 0.5);
//   color: #ffffffc0;
//   width: 100%;
//   height: 100%;
//   padding: 20px;
//   text-align: right;
//   font-size: 2.7rem;
//   z-index: 0;
// }
.stand-details-close-btn {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 90%;
  text-align: right;
  font-size: 2.7rem;
  // background-color: red;
  color: #ffffffc0;
  width: 100%;
  height: 100px;
  padding: 20px;
  z-index: 3;
}
.stand-background-container {
  display: flex;
  justify-content: stretch;
  width: 100%;
  min-height: 95vh;
  padding: 4% 0%;
  margin-top: 80px;
  .stands-iframe {
    flex-grow: 1;
  }
}
.foyer2d-instructions {
  display: none;
}
@include media('<=phone-plus') {
  .area-and-overlay-items {
    overflow: scroll;
    position: absolute;
    // min-width: 1920px;
    // left: -600px;
    // display: flex;
    // justify-content: center;
  }
  // .stands-background-image {
  //   // height: 100%;
  //   // min-width: 1920px;
  // }
  // .overlay-item {
  //   // position: absolute;
  // }
  .stand-popup-first-wrapper {
    // background-color: teal;
    // flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 40%;
    height: 100%;
    padding-right: 5%;

    img {
      max-width: 18vw;
    }
    h2 {
      padding: 2% 0%;
    }
    .stand-description {
      font-size: 1rem;
      max-height: 260px;
      // overflow-y: auto;
    }
    .stand-btns {
      flex-wrap: wrap;
      .stand-btn {
        padding: 10px;
        // font-size: 2.4vw;
      }
    }
  }

  // .stand-close-btn {
  //   width: 40px;
  //   height: 40px;
  //   font-size: 30px;
  // }

  .foyer2d-instructions {
    display: block;
    max-width: 120px;
    opacity: 0.7;
  }
}
@include media('<=phone') {
  .stand-popup-container {
    position: fixed;
    top: 50px;
  }
  .stand-details-container {
    position: fixed;
    top: 50px;
  }
  .stand-popup-first-wrapper {
    // background-color: teal;
    // flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 40%;
    height: 100%;
    padding-right: 5%;

    img {
      max-width: 18vw;
    }
    h2 {
      font-size: 1.2rem;

      padding: 2% 0%;
    }
    .stand-description {
      font-size: 0.8rem;
      height: 120px;
      // overflow-y: auto;
    }
    .stand-btns {
      flex-wrap: wrap;
      .stand-btn {
        padding: 10px;
        font-size: 0.6rem;
      }
    }
  }
}
@media (max-height: 460px) {
  .stand-popup-container {
    position: fixed;
    top: 50px;
  }
  .stand-details-container {
    position: fixed;
    top: 50px;
  }
}
</style>
